export default "__VITE_ASSET__Dl$uuqHV__"